<template>
  <a-layout class="problem-report">
    <TitleBreadcrumb />
    <div class="content-base container">
      <a-row type="flex" justify="center" :gutter="[16, 16]">
        <a-col :md="16">
          <ProblemReportForm />
        </a-col>
      </a-row>
    </div>
  </a-layout>
</template>
<script>
import ProblemReportForm from "@/components/ProblemReportForm.vue";
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb.vue";
import loadingMixin from "@/mixins/loadingMixin";
import { pageTitle } from "../../utils/utils";
import labels from "@/utils/labels";
export default {
  components: { TitleBreadcrumb, ProblemReportForm },
  name: "ProblemReport",
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.problemReportForm.subtitle),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.problemReportForm.subtitle,
      },
    ],
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.problem-report {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  .content-base {
    padding-top: 60px;
    @media screen and (max-width: $screen-mobile) {
      max-width: 100% !important;
      padding-top: 14px;
    }
  }
}
</style>
